<template>
  <b-container fluid class="form login-form">
    <b-row>
      <b-col lg="6" md="6" sm="12" class="left-side position-relative">
        <LanguageFlagDropdown class="login-lang-switcher" />
        <b-row class="position-relative">
          <b-col lg="9" md="12" sm="12" class="m-md-0 my-0 my-md-5">
            <div class="fix-width fix-width-login">
              <div class="logo mb-3 pb-3 text-left">
                <b-img class="" :src="require('@/assets/new-logo.png')" width="300" height="50"></b-img>
              </div>
              <!-- <div class="heading text-left mb-4">
                <h1 class="mb-0">Welcome Back</h1>
                <p>Sign in to continue to Digital Permit Book</p>
              </div> -->
              <b-form @submit.prevent="onLogin" v-if="!isGeotabAddin">
                <b-form-group id="input-group-1" :label="$t('login.emailLabel')" label-for="input-1"
                  class="text-left label">
                  <b-form-input id="input-1" type="email" class="mb-3 input" required
                    :placeholder="$t('login.emailPlaceholder')" v-model="user.username"></b-form-input>
                </b-form-group>

                <b-form-group id="input-group-2" :label="$t('login.passwordLabel')" label-for="input-2"
                  class="text-left label password auth-form-group" v-if="showPasswordField">
                  <b-form-input id="input-2" class="mb-3 input" required :placeholder="$t('login.passwordPlaceholder')"
                    :type="showPassword ? 'text' : 'password'" v-model="user.password"></b-form-input>

                  <b-icon :icon="showPassword ? 'eye-fill' : 'eye-slash-fill'"
                    @click="showPassword = !showPassword"></b-icon>
                </b-form-group>
                <div class="text-left mb-3">
                  <router-link v-if="showPasswordField" class="font-weight-normal opacity-50 f-14"
                    to="/forgot-password">{{ $t('login.forgotPassword') }}</router-link>
                </div>
                <!-- <b-form-group
                  id="input-group-4"
                  class="text-left position-relative"
                >
                  <b-form-checkbox-group id="checkboxes-4">
                    <b-form-checkbox value="that">Remember me</b-form-checkbox>
                  </b-form-checkbox-group>
                </b-form-group> -->

                <b-button type="submit" class="w-100 mt-2 login h-40px" variant="primary">{{ showPasswordField ?
                  $t('login.logIn') : $t('login.continue') }}</b-button>
              </b-form>

              <div class="social-divider my-3" v-if="!isGeotabAddin">
                <span class="divider-line"></span>
                <span class="divider-text">{{ $t('login.or') }}</span>
                <span class="divider-line"></span>
              </div>

              <b-button v-if="!isGeotabAddin" class="w-100 social-btn google-btn mb-2" @click="socialLogin('google')">
                <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google"
                  class="social-icon mr-2" />
                {{ $t('login.signInWithGoogle') }}
              </b-button>
              <b-button v-if="!isGeotabAddin" class="w-100 social-btn microsoft-btn mb-3"
                @click="socialLogin('microsoft')">
                <img
                  src="https://docs.microsoft.com/en-us/azure/active-directory/develop/media/howto-add-branding-in-azure-ad-apps/ms-symbollockup_mssymbol_19.svg"
                  alt="Microsoft" class="social-icon" />
                {{ $t('login.signInWithMicrosoft') }}
              </b-button>

              <div class="signup mt-3" v-if="!isGeotabAddin">
                {{ $t('login.noAccount') }}
                <router-link to="/register">{{ $t('login.signupNow') }}</router-link>
              </div>
              <b-button @click="loginWithGeoTab" v-if="isGeotabAddin" class="w-100 social-btn microsoft-btn mb-3">
                <img :src="require('@/assets/geo-tab-table.svg')" alt="GeoTab" class="social-icon" />
                {{ $t('login.signInWithGeoTab') }}
              </b-button>
              <div class="otp-bubble mt-4 text-center d-flex align-items-center justify-content-center"
                v-if="showGeoTabError">
                <p class="mb-0 f-14">{{ $t('login.helpGettingStarted') }}</p>
                <p class="mb-0 f-14 ml-2"><a
                    href="https://help.digitalpermitbook.com/en/articles/13189302-geotab-order-now-add-in" target="_blank"
                    rel="noopener noreferrer"><u>{{ $t('login.clickHere') }}</u></a></p>
              </div>
            </div>
          </b-col>
          <!-- <p class="mb-0 f-14 opacity-50 copyright-text">© {{new Date().getFullYear()}} Copyright Digital Permit Book LLC.</p> -->
        </b-row>
      </b-col>
      <b-col cols="6" md="6" class="p-0 auth-bg-img" :class="{ 'vh-100': isGeotabAddin }">
        <Auth />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Auth from "@/components/auth/Auth.vue";
import LanguageFlagDropdown from "@/components/Shared/LanguageFlagDropdown.vue";
import { mapActions, mapGetters } from "vuex";
import { getGeotabSession } from "@/services/geotab";
import { takePendingRedirect } from "@/services/helper";
export default {
  components: { Auth, LanguageFlagDropdown },
  name: "Login",
  data() {
    return {
      showPassword: false,
      showPasswordField: false,
      showGeoTabError: false,
      user: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapGetters(["isGeotabAddin"]),
  },
  methods: {
    ...mapActions(["loginUser", "setNotification", "getUserCompanies", "setLoader", "checkLoginMethod", "globalCallAuthBack", "checkSocialLogin", "loginGeoTabUser"]),
    async loginWithGeoTab() {
      try {
        this.setLoader(true)
        const session = await getGeotabSession()
       const { eula_accepted_at } = await this.loginGeoTabUser({
          username: session.username,
          sessionId: session.sessionId,
          database: session.database,
          server: session.server,
          lang: this.$route.query.lang || 'en'
        })
        this.setNotification({
          msg: this.$t('login.loginSuccess'),
          type: "success",
          color: "green",
        })
        this.setLoader(false)
        if(!eula_accepted_at) this.$router.push("/eula")
        else this.$router.push("/")
      }
      catch (error) {
        this.showGeoTabError = false
        this.setLoader(false)
        const msgError = (typeof error === 'string' ? error : (error?.error || error?.response?.data?.error || error?.message)) || this.$t('login.loginFailed')
        if (msgError === this.$t('login.databaseSetupError')) this.showGeoTabError = true
          this.setNotification({
            msg: msgError,
            type: "error",
            color: "red",
          });
      }
    },
    async socialLogin(type) {
      try {
        const { redirect_url } = await this.checkSocialLogin(type)
        if (redirect_url) window.location.href = redirect_url
      }
      catch (error) {
        this.setNotification({
          msg: error,
          type: "error",
          color: "red",
        });
      }
    },
    async handleSSOCallBack() {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');

      if (code && !urlParams.get('token')) {
        this.setLoader(true);
        try {
          const response = await this.globalCallAuthBack({ code, state });
          if (response.redirect_to_okta && response.redirect_url) {
            window.location.href = response.redirect_url
            return;
          }
          if (response.token) {
            localStorage.setItem("token", response.token);
            this.setNotification({
              msg: "Successfully Login",
              type: "success",
              color: "green",
            });
            await this.getUserCompanies();
            // Clean up URL
            window.history.replaceState({}, document.title, window.location.pathname);
            if (localStorage.getItem("userSelectedCompany")) {
              this.$router.push("/");
            } else {
              this.$router.push("/all-companies");
            }
          }
        } catch (error) {
          this.setNotification({
            msg: error,
            type: "error",
            color: "red",
          });
          // Clean up URL on error
          window.history.replaceState({}, document.title, window.location.pathname);
        } finally {
          this.setLoader(false);
        }
      }
    },
    async onLogin() {
      if (!this.user.username) {
        this.setNotification({
          msg: this.$t('login.enterCredentials'),
          type: "error",
          color: "red",
        });
      } else {
        try {
          if (!this.showPasswordField) {
            const data = await this.checkLoginMethod({ email: this.user.username })
            if (data.login_with === "password") this.showPasswordField = true
            else if (data.redirect_url) window.location.href = data.redirect_url
          }
          else {
            const { key, eula_accepted_at } = await this.loginUser({
              payload: {
                email: this.user.username,
                password: this.user.password
              },
              registerCompany: false
            });

            if (key) {
              this.setNotification({
                msg: this.$t('login.loginSuccess'),
                type: "success",
                color: "green",
              });
              await this.getUserCompanies()
              if(!eula_accepted_at) this.$router.push("/eula")
              else {
                // Somebody who arrived on an authorization request finishes it
                // rather than being dropped on the dashboard; that screen asks
                // which company to connect, so it needs no company picked yet.
                const pending = takePendingRedirect();
                if (pending) this.$router.push(pending);
                else if (localStorage.getItem("userSelectedCompany")) this.$router.push("/")
                else this.$router.push("/all-companies");
              }
            }
          }
        } catch (error) {
          this.setNotification({
            msg: error,
            type: "error",
            color: "red",
          });
        }
      }
    },
  },
  async mounted() {
    if (this.$route.query.code) {
      this.handleSSOCallBack();
      return;
    }
    if (this.$route.query.token) {
      this.setLoader(true)
      localStorage.setItem("token", this.$route.query.token)
      setTimeout(() => {
        this.setLoader(false)
        this.$router.push("/")
      }, 2000);
    }
    if (this.isGeotabAddin) {
      this.loginWithGeoTab()
    }
    localStorage.removeItem("userSelectedCompany")
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins&display=swap");
/* .login-form .right-img {
  

  height: calc(100vh) ;
  overflow: hidden;
} */

.left-side {
  background-color: white;
}

.right-img img {
  object-fit: cover;
  height: 100%;
}

.fix-width {
  width: 397px;
}

.left-side {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .form {
  background-color: #f8f8f8;
} */
.heading h1 {
  font-size: 32px;
  line-height: 48px;
  font-weight: 700;
  color: var(--btn-color);
}

.heading p {
  font-size: var(--small);
  line-height: 21px;
  font-weight: 400;
  color: var(--black);
  opacity: 0.6;
}

.label {
  font-size: var(--small) !important;
  font-weight: 500;
  line-height: 21px;
  font-family: poppins;
  position: relative;
}

.input {
  border: 1px solid #e3e3e3 !important;
  background-color: #f5f5f5 !important;
  border-radius: 5px !important;
}

.input.h-50px,
.vue-tel-input.h-50px {
  height: 50px !important;
}

.forgot {
  position: absolute;
  right: 0;
  top: 0;
  text-decoration: none;
  color: var(--black);
  opacity: 0.6;
  font-size: var(--extrasmall);
  line-height: 18px;
}

.forgot:hover {
  color: var(--black);
  opacity: 0.6;
}

.login {
  background-color: var(--btn-bg-color) !important;
  border: none !important;
  font-size: var(--small) !important;
  height: 40px;
}

.signup {
  color: var(--black);
  font-size: var(--small);
  line-height: 21px;
  font-family: poppins;
}

.signup a {
  color: var(--btn-color) !important;
  font-weight: 600;
  text-decoration: none;
}

.custom-control-input[type="checkbox"] {
  cursor: pointer;
  visibility: hidden;
  overflow: hidden;
  margin-right: 5px;
  width: 19px;
  height: 19px;
  top: 4px;
  position: relative;
}

.custom-control-label {
  font-size: var(--small);
  font-weight: 400;
  padding-top: 2px;
  color: var(--black);
}

.custom-control-input[type="checkbox"]::after {
  content: " ";
  display: inline-block;
  visibility: visible;
}

.custom-control-input[type="checkbox"]::before {
  content: " ";
  position: absolute;
  top: 0;
  border-radius: 3px;
  width: 19px;
  height: 19px;
  display: inline-block;
  visibility: visible;
  border: 1px solid #c7c7c7;
}

.custom-control-input[type="checkbox"]:checked::after {
  content: "\2714";
  font-size: 10px;
  text-align: center;
  width: 17px;
  height: 17px;
  position: relative;
  left: 1px;
  top: -5px;
  background-color: #fff;
  color: var(--btn-color);
  border-radius: 3px;
}

.custom-control-inline {
  padding-left: 0 !important;
}

.login-form .b-icon :not(svg) {
  color: var(--black);
}

.password {
  position: relative;
}

.password .b-icon {
  position: absolute;
  top: 42px;
  right: 13px;
}

.auth-form-group.password .b-icon {
  top: 42px;
}

.copyright-text {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
}

.h-50px .vs__actions {
  padding: 10px 6px 0 3px !important;
}

@media (min-width: 1201px) {
  .login-form .auth-bg-img {
    height: 100vh;
  }
}

@media (max-width: 1200px) {
  .fix-width.fix-width-login {
    width: 397px !important;
  }

  /* .login-form .right-img{
    height: 100%;
    height: calc(100vh);
  } */
  .auth-bg-img {
    height: auto;
  }
}

@media (max-width: 991px) {
  .fix-width.fix-width-login {
    width: auto !important;
  }

  .right-img {
    height: 100%;
  }

  /* .right-img img{
    height: calc(100vh);
    height: 100%;
    object-fit: cover;
  } */
}

@media (max-width: 767px) {
  .auth-bg-img {
    display: none;
  }
}

@media (max-width: 568px) {
  .login-form .row {
    height: 100vh;
  }
}

/* Social Login Styles */
.social-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.divider-line {
  flex: 1;
  height: 1px;
  background-color: #e3e3e3;
}

.divider-text {
  color: #888;
  font-size: 12px;
  font-weight: 500;
}

.social-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  height: 40px;
  border: 1px solid #e3e3e3 !important;
  background-color: #fff !important;
  color: #333 !important;
  font-size: 14px !important;
  font-weight: 500;
  border-radius: 5px !important;
  transition: background-color 0.2s ease;
}

.social-btn:hover {
  background-color: #f5f5f5 !important;
}

.social-icon {
  width: 18px;
  height: 18px;
}

.login-lang-switcher {
  position: absolute !important;
  top: 16px;
  right: 16px;
  z-index: 5;
}

.google-btn:hover {
  border-color: #4285f4 !important;
}

.microsoft-btn:hover {
  border-color: #00a4ef !important;
}
</style>